import { render } from "./DipaReportsTableDialog.vue?vue&type=template&id=0a96cad4"
import script from "./DipaReportsTableDialog.vue?vue&type=script&lang=js"
export * from "./DipaReportsTableDialog.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__